class ProductFocusBlock extends HTMLElement {
  constructor() {
    super();

    this.splideElement = this.querySelector(".splide");
    if (!this.splideElement) {
      return;
    }
    this.isFull = this.splideElement.classList.contains("full");
    this.splideId = this.splideElement.getAttribute("id");
    document.addEventListener("DOMContentLoaded", () => {
      this.initSplide();
    });
  }

  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        if (!event.data.variant.id) {
          return;
        }
        fetch(
          `${this.dataset.url}?variant=${event.data.variant.id}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.innerHTML = html.querySelector(`#${this.id}`).innerHTML;
            this.initSplide();
          })
          .catch((e) => {
            console.error(e);
          });
      }
    );
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
    this.stopAutoScroll();
  }

  initSplide() {
    this.autoScroll = this.splideElement.dataset.autoScroll === "true";
    this.autoScrollInterval = parseInt(this.splideElement.dataset.autoScrollInterval || "5000", 10);
    this.autoScrollTimer = null;
    this.isDetailed = !!this.splideElement.querySelector(".splide__slide--detailed");

    this.splide = new Splide("#" + this.splideId, {
      perPage: 3,
      perMove: 1,
      updateOnMove: true,
      snap: true,
      drag: true,
      trimSpace: true,
      pagination: this.splideElement.hasAttribute("data-pagination")
        ? this.splideElement.getAttribute("data-pagination") == "false"
          ? false
          : true
        : false,
      arrows: false,
      flickPower: 100,
      flickMaxPages: 1,
      focus: 0,
      gap: this.isFull ? "1px" : "calc(var(--padding-sections-desktop) / 2)",
      padding: {
        right: this.isFull
          ? "calc(var(--padding-sections-desktop) * 5)"
          : "calc(var(--padding-sections-desktop) * 2)",
      },
      breakpoints: {
        4000: {
          perPage: this.isDetailed ? 4 : 3,
          padding: {
            right: this.isFull
              ? "calc(var(--padding-sections-desktop) * 5)"
              : "calc(var(--padding-sections-desktop) * 2)",
          },
        },
        2200: {
          perPage: 3,
          padding: {
            right: this.isFull
              ? "calc(var(--padding-sections-desktop) * 5)"
              : "calc(var(--padding-sections-desktop) * 2)",
          },
        },
        1199: {
          perPage: 2,
          padding: {
            left: 0,
            right: "calc(var(--padding-sections-desktop) * 2)",
          },
        },
        549: {
          perPage: 1,
          padding: {
            left: this.isDetailed
              ? 0
              : this.isFull
                ? "var(--padding-sections-desktop)"
                : "calc(var(--padding-sections-desktop) * 2)",
            right: this.isDetailed
              ? "calc(var(--padding-sections-desktop) + var(--space-7))"
              : this.isFull
                ? "var(--padding-sections-desktop)"
                : "calc(var(--padding-sections-desktop) * 2)",
          },
          trimSpace: true,
        },
      },
    });

    this.splide.mount();

    this.splide.on("move", (newIndex) => {
      this.onSlideMove(newIndex);
    });

    this.splide.on("click", (slide) => {
      this.stopAutoScroll();
      this.splide.go(slide.index);
      const video = slide.slide.querySelector("video");
      if (video) {
        video.play();
      }
    });

    this.splide.on("active", (slide) => {
      const video = slide.slide.querySelector("video");
      if (video) {
        video.play();
      }
    });

    this.splide.on("inactive", (slide) => {
      const videos = slide.slide.querySelectorAll("video");
      if (videos.length) {
        videos.forEach((video) => {
          video.pause();
        });
      }
    });

    // Stop auto scroll on drag
    this.splide.on("drag", () => {
      this.stopAutoScroll();
    });

    // Behavior for videos
    const videos = this.querySelectorAll("video");
    videos.forEach((video) => {
      video.addEventListener("play", () => {
        const parent = video.closest(".splide__slide");
        if (!parent.classList.contains("is-active")) {
          this.pauseAllVideos(video);
        }
        const index = parseFloat(parent.getAttribute("data-slide-index"));
        this.splide.go(index);
      });
    });

    this.startAutoScroll();
  }

  startAutoScroll() {
    if (!this.autoScroll || this.splide.length <= 1) return;
    this.stopAutoScroll();
    this.autoScrollTimer = setInterval(() => {
      const next = this.splide.index < this.splide.length - 1
        ? this.splide.index + 1
        : 0;
      this.splide.go(next);
    }, this.autoScrollInterval);
  }

  stopAutoScroll() {
    if (this.autoScrollTimer) {
      clearInterval(this.autoScrollTimer);
      this.autoScrollTimer = null;
    }
  }

  onSlideMove(newIndex) {
    const relatedContent = this.querySelectorAll(".js-slide-content");
    if (relatedContent.length) {
      relatedContent.forEach((content) => {
        if (parseFloat(content.getAttribute("data-slide-index")) !== newIndex) {
          content.classList.add("hidden");
        } else {
          content.classList.remove("hidden");
        }
      });
    }
  }

  pauseAllVideos(except) {
    const videos = this.querySelectorAll("video");
    if (videos.length) {
      videos.forEach((video) => {
        if (video !== except) {
          video.pause();
        }
      });
    }
  }
}

customElements.define("product-focus-block", ProductFocusBlock);